<template>
  <div id="app">
    <v-app id="inspire">

      <body>
        <p align="center">
          <b>
            <font face="Arial">Informes del Representante de la Dirección</font>
          </b>
        </p>
        <table border="1" cellspacing="1" width="100%" id="AutoNumber1">
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0020.pdf">1º semestre
                  del
                  2006</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0021.pdf">2º semestre
                  del
                  2006</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0022.pdf">1º semestre
                  del
                  2007</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0023.pdf">2º semestre
                  del
                  2007</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0024.pdf">1º semestre
                  del
                  2008</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0025.pdf">2º semestre
                  del
                  2008</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0026.pdf">1º semestre
                  del
                  2009</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0027.pdf">2º semestre
                  del
                  2009</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0028.pdf">1º semestre
                  del
                  2010</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0029.pdf">2º semestre
                  del
                  2010</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0030.pdf">1º semestre
                  del
                  2011</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0031.pdf">2º semestre
                  del
                  2011</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0032.pdf">1º semestre
                  del
                  2012</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0033.pdf">2º semestre
                  del
                  2012</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0034.pdf">1º semestre
                  del
                  2013</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0035.pdf">2º semestre
                  del
                  2013</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0036.pdf">1º semestre
                  del
                  2014</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0037.pdf">2º semestre
                  del
                  2014</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0038.pdf">1º semestre
                  del
                  2015</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0039.pdf">2º semestre
                  del
                  2015</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0040.pdf">1º semestre
                  del
                  2016</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0041.pdf">2º semestre
                  del
                  2016</a>
              </font>
            </td>
          </tr>

          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0042.pdf">1º semestre
                  del
                  2017</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0043.pdf">2º semestre
                  del
                  2017</a>
              </font>
            </td>
          </tr>

          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0044.pdf">1º semestre
                  del
                  2018</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0045.pdf">2º semestre
                  del
                  2018</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a htarget="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0046.pdf">1º semestre
                  del
                  2019</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0047.pdf">2º semestre
                  del
                  2019</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0048.pdf">1º semestre
                  del
                  2020</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0049.pdf">2º semestre
                  del
                  2020</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0050.pdf">1º semestre
                  del
                  2021</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0051.pdf">2º semestre
                  del
                  2021</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0052.pdf">1º semestre
                  del
                  2022</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfRepresent/EI%20009-0053.pdf">2º semestre
                  del
                  2022</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                1° semestre del 2023 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0054')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                2° semestre del 2023 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0055')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                1° semestre del 2024 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0056')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                2° semestre del 2024 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0057')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                1° semestre del 2025 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0058')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                2° semestre del 2025 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0059')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
          </tr>
               <!-- <tr>
            <td width="50%" align="center">
              <font face="Arial">
                Año 2025 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI009-0058')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                -
                </v-icon>
              </font>
            </td>
          </tr> -->
        </table>
      </body>
      <VerDoc :visible="showDoc" :doc="this.doc" @close="showDoc = false">
      </VerDoc>
    </v-app>
  </div>
</template>

<script>
import VerDoc from "../Direccion/Visualizardoc.vue";
export default {
  components: { VerDoc },
  data: (vm) => ({
    doc: "",
    showDoc: false,
  }),
  computed: {
    show: {
      get() {

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {

    verDoc(item) {
      this.doc = item;
      this.showDoc = true;
    },
  },
};
</script>